<template>
  <section class="razor-calibrator">
    <div
      class="razor-calibrator__main"
      :style="`background-image: url(${require(`../assets/images/orange-${chosenOption.detail.angle}.png`)});`"
    >
      <div class="razor-calibrator__main--outcome">
        <img
          class="icon"
          :src="require(`../assets/images/${outcomeImage}.svg`)"
        />
        <h5>{{ outcomeText }}</h5>
      </div>
      <img
        class="razor-calibrator__main--image"
        :style="`top: ${chosenOption.detail.top + scale}px; width: ${
          chosenOption.detail.width
        }%; ${
          chosenOption.detail.left &&
          `left: ${chosenOption.detail.left + scale}px; width: ${
            chosenOption.detail.width
          }%`
        }`"
        :src="require(`../assets/images/${chosenOption.detail.image}.png`)"
      />
    </div>
    <div class="razor-calibrator__side-bar">
      <select class="dropdown" v-model="chosenOption">
        <option
          v-for="(option, i) in content.options"
          :key="`filter_${i}`"
          :value="option"
        >
          {{ option.name }}
        </option>
      </select>
      <h5>{{ content.specifications }}</h5>
      <p>{{ chosenOption.detail.body_1 }}</p>
      <p>{{ chosenOption.detail.body_2 }}</p>
      <h5>{{ content.proximity }}</h5>
      <div class="razor-calibrator__side-bar--scale">
        <img class="icon" src="../assets/images/box-down.svg" />
        <vue-slider class="slider" v-model="scale" />
        <img class="icon" src="../assets/images/box-up.svg" />
      </div>
      <h5>{{ content.reading }}</h5>
      <div class="razor-calibrator__side-bar--angle">
        <h2>{{ chosenOption.detail.angle }}°</h2>
      </div>
    </div>
  </section>
</template>

<script>
import VueSlider from 'vue-slider-component'
import 'vue-slider-component/theme/antd.css'

export default {
  name: 'RazorCalibrator',
  components: {
    VueSlider,
  },
  props: {
    content: {
      type: Object,
      default: () => {},
      required: true,
    },
  },
  computed: {
    outcomeImage() {
      return this.scale < 50
        ? this.content.cross.image
        : this.content.tick.image
    },
    outcomeText() {
      return this.scale < 50
        ? this.content.cross.outcome
        : this.content.tick.outcome
    },
  },
  data() {
    return {
      chosenOption: this.content.options[0],
      scale: 50,
    }
  },
}
</script>

<style lang="scss">
.razor-calibrator {
  position: relative;
  border-radius: 30px;
  width: 100%;
  border: 2px solid var(--color-charcoal-1);
  &__main {
    width: 100%;
    background-color: var(--color-mozzarella-2);
    border-radius: 30px;
    background-size: cover;
    height: 820px;
    &--image {
      margin-left: 10%;
      position: absolute;
    }
    &--outcome {
      position: absolute;
      display: -webkit-box;
      display: -ms-flexbox;
      display: flex;
      top: 5%;
      left: 5%;
      h5 {
        width: 40%;
        color: var(--color-white-1);
        margin-left: 10px;
      }
      .icon {
        width: 30px;
      }
    }
  }
  &__side-bar {
    background-color: var(--color-white-1);
    padding: 20px;
    border: 2px solid var(--color-charcoal-1);
    position: absolute;
    border-radius: 30px;
    top: 20px;
    right: 1%;
    height: 740px;
    width: 20%;
    &--scale {
      display: flex;
      -webkit-box-pack: justify;
      -ms-flex-pack: justify;
      justify-content: space-between;
      -webkit-box-align: center;
      -ms-flex-align: center;
      align-items: center;
      .slider {
        width: 100% !important;
      }
      .icon {
        margin: 0 10px;
        width: 30px;
      }
    }
    &--angle {
      background-color: var(--color-mozzarella-3);
      border-radius: 30px;
      width: 100%;
      text-align: center;
      height: 100px;
      border: 2px solid var(--color-charcoal-1);
      h2 {
        padding: 0;
        margin: 0 25%;
        font-size: 70px;
      }
    }
  }
}
.vue-slider-dot-tooltip {
  display: none;
}
.vue-slider-process,
.vue-slider:hover .vue-slider-process {
  background-color: var(--color-charcoal-1);
  border: none;
}
.vue-slider-dot-handle-focus,
.vue-slider-dot-handle {
  border-color: var(--color-charcoal-1);
  background-color: var(--color-charcoal-1);
  border: 2px solid var(--color-charcoal-1);
  box-shadow: none;
}
.vue-slider:hover .vue-slider-dot-handle-focus,
.vue-slider:hover .vue-slider-dot-handle:hover,
.vue-slider:hover .vue-slider-dot-handle {
  border-color: var(--color-charcoal-1);
}
.dropdown {
  width: 100%;
}
</style>